import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 1rem 2rem;
`;

export const ForbiddenError = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1rem 2rem;
`;

export const TabPage = styled.div`
  margin-top: 1rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;
